import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import API_CONFIG from '../API_CONFIG/API_CONFIG';
import AllMenu from './AllMenu';

const colors = {
  gold: '#C69C6D',
  goldDark: '#B88A56',
  text: '#3B2F2A',
  textSoft: '#5C4A3D',
  glassBg: 'rgba(255, 255, 255, 0.7)',
  glassBorder: 'rgba(198, 156, 109, 0.3)',
  shadow: '0 4px 12px rgba(107, 90, 70, 0.06)',
};

const CategorieMenu = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      const uniqueParam = new Date().getTime();
      const response = await axios.get(
        `${API_CONFIG.apiUrl}CategorieForSite.php?unique=${uniqueParam}`
      );
      setCategories(response.data);
      if (response.data.length > 0 && !selectedCategory) {
        setSelectedCategory(response.data[0].id_cat);
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des catégories :', error);
    }
  }, [selectedCategory]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <style>{`
        .categorie-menu-container {
          text-align: center;
        }

        .categorie-buttons {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 12px;
          margin-bottom: 40px;
        }

        .cat-btn {
          background: ${colors.glassBg};
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          border: 1px solid ${colors.glassBorder};
          border-radius: 50px;
          padding: 10px 24px;
          font-size: 0.95rem;
          font-weight: 500;
          color: ${colors.text};
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: ${colors.shadow};
          text-transform: capitalize;
          white-space: nowrap;
        }

        .cat-btn:hover {
          background: rgba(255, 255, 255, 0.9);
          border-color: ${colors.gold};
          color: ${colors.gold};
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(184, 138, 86, 0.2);
        }

        .cat-btn.active {
          background: linear-gradient(135deg, ${colors.gold}, ${colors.goldDark});
          color: white;
          border-color: transparent;
          box-shadow: 0 8px 20px rgba(198, 156, 109, 0.4);
        }

        .cat-title {
          font-size: 1.5rem;
          font-weight: 600;
          color: ${colors.text};
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        .cat-title span {
          font-weight: 400;
          color: ${colors.textSoft};
        }

        @media (max-width: 576px) {
          .cat-btn {
            padding: 8px 18px;
            font-size: 0.85rem;
          }
        }
      `}</style>

      <div className="categorie-menu-container">
        {/* Boutons de catégories */}
        <div className="categorie-buttons">
          {categories.map((cat) => (
            <motion.button
              key={cat.id_cat}
              className={`cat-btn ${selectedCategory === cat.id_cat ? 'active' : ''}`}
              onClick={() => setSelectedCategory(cat.id_cat)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {cat.categories}
            </motion.button>
          ))}
        </div>

        {/* Affichage de la catégorie sélectionnée */}
        <AnimatePresence mode="wait">
          {selectedCategory && (
            <motion.div
              key={selectedCategory}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
            >
              <div className="cat-title">
                <span>Notre sélection</span> –{' '}
                {categories.find((c) => c.id_cat === selectedCategory)?.categories}
              </div>
              <AllMenu id_cat={selectedCategory} />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default CategorieMenu;